import React from 'react'
import { Link } from 'react-router-dom'

export default function RouterLink({ style, catId }) {
  return (
    <Link to={`/cat/${catId}`}>Details</Link>
  )
}
